// extracted by mini-css-extract-plugin
var _1 = "TeamIcon-module__animateUploadProgressBarWidth--xhPtz";
var _2 = "TeamIcon-module__animatedBackground--LT02P";
var _3 = "TeamIcon-module__large--WS4l8";
var _4 = "TeamIcon-module__medium--WFwJn";
var _5 = "TeamIcon-module__regular--qmrN_";
var _6 = "TeamIcon-module__small--f2PNE";
var _7 = "TeamIcon-module__teamIconDefault--Z_rk4";
var _8 = "TeamIcon-module__withBackground--B8Am5";
var _9 = "TeamIcon-module__xlarge--YARxs";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "large", _4 as "medium", _5 as "regular", _6 as "small", _7 as "teamIconDefault", _8 as "withBackground", _9 as "xlarge" }
